const API_BASE_HOST = 'https://cas.xcxd.net.cn/api'
export default {

	title: '后台管理系统',

	api: {
		limit: 20,
		baseURL: `${API_BASE_HOST}/admin`,
		uploadURL: `${API_BASE_HOST}/admin/upload`,
		imageURL: ``,
	},
	upload: {
		"url": API_BASE_HOST + "/admin/upload",
		"image": {
			"limit": 1024 * 1024 * 2,
			"allow": ["jpg", "jpeg", "png"],
			"accept": "image/jpg, image/jpeg, image/png",
			"tips": "图片格式支持：png,jpeg,jpg；不可大于2M；建议使用png格式图片，以保持最佳效果；建议图片尺寸为200px*200px"
		},
		"video": {
			"limit": 1024 * 1024 * 5,
			"allow": ["mp4"],
			"accept": "video/mp4",
			"tips": "视频格式支持：mp4；不可大于5M；"
		}
	}
}